import React from 'react'
import PropTypes from 'prop-types'
import ExperienceBadge from './ExperienceBadge'
import { WHERE_LABELS, WHERE_COLOR_VARIANT } from './experienceNavigation'

/**
 * Caps label + optional where-pills (Admin / Prosperity / Participant).
 * Text + pills sit in one flex row (v7 `.f label` + `.where`).
 */
const ExperienceFieldLabel = ({ children, where = [] }) => (
  <>
    <span>{children}</span>
    {where.map((key) => (
      <ExperienceBadge
        key={key}
        title={WHERE_LABELS[key] || key}
        variant={WHERE_COLOR_VARIANT[key] || 'taupe'}
      />
    ))}
  </>
)

ExperienceFieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  where: PropTypes.arrayOf(PropTypes.string),
}

export default ExperienceFieldLabel
